export default defineNuxtRouteMiddleware(({ path }) => {
  const { $i18n } = useNuxtApp();
  if (!path.includes(STARTUPS_BASE_URL)) {
    if ($i18n.locale.value !== process.env.APP_LOCALE) {
      $i18n.setLocale(process.env.APP_LOCALE as "es" | "en" || "es");
    }
  }
});
